/* unplugin-vue-components disabled */import script from "./reserve_Street.vue?vue&type=script&setup=true&lang=ts"
export * from "./reserve_Street.vue?vue&type=script&setup=true&lang=ts"

import "./reserve_Street.vue?vue&type=style&index=0&id=2f4f453a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4f453a"]])

export default __exports__